<div class="mat-typography" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h2 mat-dialog-title cdkDragHandle>Return {{firearmTypeName}}</h2>
  <mat-dialog-content class="dialog-content">
    <div>
      <form [formGroup]="form">

        <div *ngIf="hasPendingActions">
          <div class="crud-item-section">
            <span class="crud-editor-warning">Currently this {{firearmTypeName}} has assignment actions
              pending. Please progress these before returning the firearm.</span>
          </div>
        </div>

        <div *ngIf="!currentlyIssued && !hasPendingActions">
          <div class="crud-item-section">
            <span class="crud-editor-info">{{firearmTypeName}} is not currently issued.</span>
          </div>
        </div>

        <div *ngIf="currentlyIssued && !hasPendingActions">
          <div class="crud-item-section">
            <span>Currently this {{firearmTypeName}} is issued. Please select a Wildlife Manager and storage location to return it to storage:</span>
          </div>
          <div class="crud-item-section">
            <span>
              <mat-form-field matTooltip="Select a Storage Assignee from the list"
                [matTooltipDisabled]="disabledTooltip(this.storageAssignee)" class="crud-item-input-wider">
                <mat-label i18n="@@type.FirearmReturnDialogData.storageAssignee">Storage Assignee</mat-label>
                <mat-select formControlName="storageAssignee" id="storageAssignee"
                  (ngModelChange)="storageAssigneeChanging($event)" [(ngModel)]="item.storageAssignee"
                  (ngModelChange)="storageAssigneeChanged($event)" #storageAssignee
                  [compareWith]="storageAssigneeCompare">
                  <mat-option>Any</mat-option>
                  <mat-option *ngFor="let storageAssignee of storageAssigneeSelectionList" [value]="storageAssignee">
                    {{storageAssigneeDisplay(storageAssignee)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </span>
          </div>

          <div class="crud-item-section">
            <span>
              <mat-form-field matTooltip="Select a Location from the list" [matTooltipDisabled]="disabledTooltip(this.location)" class="crud-item-input-wider">
                <mat-label i18n="@@type.FirearmReturnDialogData.location">Storage Location</mat-label>
                <mat-select formControlName="location" id="location"              
                    (ngModelChange)="locationChanging($event)" [(ngModel)]="item.location"              
                    (ngModelChange)="locationChanged($event)" #location              
                    placeholder="Location" [compareWith]="locationCompare">
                  <mat-option>Any</mat-option>
                  <mat-option *ngFor="let location of locationSelectionList" [value]="location">
                    {{locationDisplay(location)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </span>
          </div>

          <div class="crud-item-section">
            <mat-form-field matTooltip="Comments" class="crud-item-input-verywide">
              <mat-label i18n="@@type.FirearmReturnDialogData.comments">Comments</mat-label>
              <textarea matInput formControlName="comments" id="comments" [(ngModel)]="item.comments" maxlength="1000"
                placeholder="Comments">
              </textarea>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button mat-raised-button color="primary" [disabled]="!isFirearmReturnEnabled()"
      (click)="firearmReturn()">Initiate {{firearmTypeName}} Return</button>
    <button mat-raised-button color="accent" (click)="closeDialog()">Close</button>
  </mat-dialog-actions>
  <div class="crud-editor-error-list" *ngIf="getFormErrorList().length > 0">
    <br>
    <h2>Errors:</h2>
    <div *ngFor="let error of getFormErrorList()" class="crud-editor-err-msg">{{error}}</div>
  </div>
</div>